module.exports = __webpack_public_path__ + "static/shoe-layers-1-46f127694dc18eebdc6ec8f5b326c579.png";